// O superagent (usado em todo o resto do app) não expõe leitura incremental no
// browser: ele só resolve a promise com o corpo inteiro. Streaming exige fetch
// + ReadableStream, então esta rota sai do apiPost e refaz à mão o que os
// middlewares faziam — headers de sessão, CSRF e o tratamento de 401.
import { getSession } from "../sessionProcesses";

const FRAME_SEPARATOR = /\r\n\r\n|\n\n|\r\r/;

// Safari só passou a expor Response.body em 14.1 (iOS 14.5). Sem isso o fetch
// resolve normalmente, mas res.body é undefined e o stream morre em silêncio —
// melhor detectar e cair na rota síncrona, que nunca deixou de funcionar.
export function supportsStreaming() {
  return (
    typeof window.fetch === "function" &&
    typeof window.ReadableStream === "function" &&
    typeof window.TextDecoder === "function" &&
    typeof window.AbortController === "function" &&
    typeof Response !== "undefined" &&
    "body" in Response.prototype
  );
}

export class UnauthorizedError extends Error {}

function authHeaders() {
  const csrfEl = document.querySelector("meta[name=csrf-token]");

  return {
    "Content-Type": "application/json",
    Accept: "text/event-stream",
    ...(csrfEl ? { "X-CSRF-Token": csrfEl.content } : {}),
    ...(getSession()?.headers || {}),
  };
}

// Replica o unauthorizedMiddleware do superagent, que esta rota não usa.
function handleUnauthorized() {
  localStorage.removeItem("session");

  if (window.location.pathname !== "/signin") {
    window.location.replace("/signin");
  }

  throw new UnauthorizedError("unauthorized");
}

function parseFrame(frame) {
  let name = "message";
  const data = [];

  frame.split(/\r\n|\n|\r/).forEach((line) => {
    if (line.startsWith(":")) return; // comentário/heartbeat
    if (line.startsWith("event:")) {
      name = line.slice(6).trim();
    } else if (line.startsWith("data:")) {
      // Só UM espaço depois do ':' é delimitador; o resto é conteúdo.
      data.push(line.slice(5).replace(/^ /, ""));
    }
  });

  if (data.length === 0) return null;

  try {
    return { name, data: JSON.parse(data.join("\n")) };
  } catch (e) {
    return null;
  }
}

export async function postEventStream(url, body, { signal, onEvent }) {
  const response = await fetch(url, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(body),
    credentials: "same-origin",
    signal,
  });

  if (response.status === 401) handleUnauthorized();

  if (!response.ok) {
    const payload = await response.json().catch(() => null);
    const error = new Error("request failed");
    error.status = response.status;
    error.body = payload;
    throw error;
  }

  if (!response.body) throw new Error("streaming not supported");

  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");
  let buffer = "";

  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;

    // stream: true faz o decoder segurar bytes de um caractere multibyte que
    // ficou partido entre dois chunks da rede.
    buffer += decoder.decode(value, { stream: true });

    let match;
    while ((match = FRAME_SEPARATOR.exec(buffer)) !== null) {
      const frame = buffer.slice(0, match.index);
      buffer = buffer.slice(match.index + match[0].length);

      const parsed = parseFrame(frame);
      if (parsed) onEvent(parsed);
    }
  }
}
